import http from '../utils/fetch'
import qs from 'qs'

export default {
  list (page) {
    return http.get({
      url: 'v1/commission',
      params: page,
    })
  },
  unfreeze(commissionId) {
    return http.post({
      url: 'v1/commission/unfreeze',
      data: qs.stringify({commissionId: commissionId})
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/commission.js